const LandingIndex = () => import('@/views/landing/flow/index.vue');
const LandingPin = () => import('@/views/landing/flow/pin.vue');
const LandingSuccess = () => import('@/views/landing/flow/success.vue');

const my_routes = [
    {
        path: '/pin/:landing_session_id?/:error_code?',
        alias: '/pin/',
        component: LandingPin,
        name: "LandingPin"
    },
    {
        path: '/success/:new_access_code?',
        alias: '/success/',
        component: LandingSuccess,
        name: "LandingSuccess"
    },
    {
        path: '*',
        component: LandingIndex,
    }];

export const landing_routes = my_routes;